export class Country {

    constructor() {}

    name: string;
    alpha2Code: string;
    alpha3Code: string;
    numericCode: string;
    currencies: string[];
    translations: any;

    Deserialize(input: any){
        this.name=input.name;
        this.alpha2Code=input.alpha2Code;
        this.alpha3Code=input.alpha3Code;
        this.numericCode=input.numericCode;
        this.currencies=input.currencies;
        this.translations=input.translations;
        return this;
    }
}